import { useState, useContext } from "react";

import { Card, FormControl } from "@mui/material";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { LanguageContext } from "App";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import {
  createUserWithEmailAndPassword,
  getAuth,
  deleteUser,
} from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import UsersApi from "../../../Classes/API/UsersApi";
import CreateUserReq from "../../../Classes/Models/Requests/Users/CreateUserReq";
import Swal from "sweetalert2";
import CountrySelector from "layouts/authentication/sign-up/CountrySelector";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";
import { useTenant } from "../../../context/TenantContext";

import "./style.scss";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import firebaseConfig from "FirebaseConfig";
import autocomplete from "assets/theme/components/form/autocomplete";
import { NationalityGroupOptions, GenderOptions } from "utils/userConstants";

// Initialize Firebase
const app2 = initializeApp(firebaseConfig, "elagiCreateUser");

const CreateClient = () => {
  const navigate = useNavigate();
  const { translations, lang } = useContext(LanguageContext);
  const [Name, setName] = useState("");
  const [Address, SetAddress] = useState("");
  const [Nationality, SetNationality] = useState("");

  const [NationalityGroup, setNationalityGroup] = useState(null);

  const [Number, SetNumber] = useState("");
  const [Referral, setReferral] = useState("");
  const [Gender, SetGender] = useState("");
  const [BirthdayDate, setBirthdayDate] = useState("");

  const [Password, SetPassword] = useState("");
  const [ConfirmPassword, SetConfirmPassword] = useState("");

  const [ErrorText, SetErrorText] = useState("");
  const [IsLoading, setIsLoading] = useState(false);

  const [Email, SetEmail] = useState("");
  const [NationalPassportId, setNationalPassportId] = useState("");
  const [RelativeNumber, setRelativeNumber] = useState("");
  const [ChronicDiseases, setChronicDiseases] = useState("");
  const [Sensitivity, setSensitivity] = useState("");
  const [Medications, setMedications] = useState("");

  const auth = getAuth(app2);
  const [user, loading, error] = useAuthState(auth);
  const { currentTenant } = useTenant();

  const tenantId = currentTenant?.id;

  const onSubmit = async () => {
    const ehonePattern = new RegExp(
      /^(?:\+?\d{1,3}[- ]?)?(?:\(?\d{1,4}\)?[- ]?)?(?:\d{1,4}[- ]?){1,3}\d{1,4}$/,
    );

    if (Name.length === 0) {
      Swal.fire({
        title: "error",
        text: translations.CreateUserName,
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }

    if (!NationalityGroup) {
      Swal.fire({
        title: "error",
        text: "Please select a Nationality Group",
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }

    if (!ehonePattern.test(Number)) {
      Swal.fire({
        title: "error",
        text: translations.PleaseEnterPhonenumber,
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }
    const calculateAge = (birthday) => {
      if (!birthday) return 0;
      const birthDate = new Date(birthday);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      return age;
    };

    setIsLoading(true);
    Swal.fire({
      title: "Creating Client",
      html: '<div style="display: flex; align-items: center; justify-content: center; gap: 10px;"><div style="border: 4px solid #f3f3f3; border-top: 4px solid #3560AD; border-radius: 50%; width: 30px; height: 30px; animation: spin 1s linear infinite;"></div><span>Please wait...</span></div>',
      icon: undefined,
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const req = new CreateUserReq();
    try {
      req.Number = "+" + Number;
      req.Address = Address;
      req.Name = Name;
      req.Gender = Gender;
      req.BirthdayDate = BirthdayDate;
      req.Referral = Referral;
      req.Nationality = Nationality;
      req.NationalityGroup = NationalityGroup ? NationalityGroup.value : "";
      req.UserType = "Patient";
      req.isActivated = true;
      req.isSoftDeleted = false;
      req.NationalId = NationalPassportId;
      req.RelativeNumber = RelativeNumber;
      req.ChronicDiseases = ChronicDiseases;
      req.Sensetivity = Sensitivity;
      req.Medications = Medications;
      req.TenantId = tenantId;

      const res = await UsersApi.CreateUser(req);

      if (res.status === "Success") {
        Swal.fire({
          title: "Success!",
          text: "Client created successfully",
          icon: "success",
          confirmButtonText: "ok",
          confirmButtonColor: "#3560AD",
        }).then(() => {
          navigate("/ManageUsers/Options", {
            state: {
              SearchUser: res.data,
            },
          });
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Failed to create client in backend.",
          icon: "error",
          confirmButtonText: "ok",
          confirmButtonColor: "#3560AD",
        });
        SetErrorText("Failed to create client in backend.");
      }
    } catch (err) {
      console.error("Backend Error:", err);
      Swal.fire({
        title: "Error",
        text: "Unexpected error while creating client.",
        icon: "error",
        confirmButtonText: "ok",
        confirmButtonColor: "#3560AD",
      });
      SetErrorText("Unexpected error while creating client.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card>
        <MDBox
          pt={2}
          px={2}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <MDTypography variant="h6" fontWeight="medium">
            {translations.CreateClient}
          </MDTypography>
          <MDButton
            onClick={() => onSubmit()}
            disabled={IsLoading}
            sx={{
              backgroundColor: "#3560AD",
              "&:hover": { backgroundColor: "#4682B4" },
              opacity: IsLoading ? 0.6 : 1,
              cursor: IsLoading ? "not-allowed" : "pointer",
            }}
            color="success"
          >
            {IsLoading ? "Creating..." : translations.CreateClient}
          </MDButton>
        </MDBox>

        <MDBox pt={2} pb={3} px={3}>
          <MDBox
            component="form"
            role="form"
            autoComplete="off"
            className={translations.setlang === "ar" ? "rtl-label" : ""}
          >
            <div className="row">
              <input
                type="text"
                name="fake-email"
                autoComplete="username"
                style={{ display: "none" }}
              />

              <input
                type="password"
                name="fake-pass-1"
                autoComplete="new-password"
                style={{ display: "none" }}
              />

              <input
                type="password"
                name="fake-pass-2"
                autoComplete="new-password"
                style={{ display: "none" }}
              />

              {/* Hidden email, password fields retained */}
              <div style={{ display: "none" }}>
                <MDInput
                  onChange={(e) => SetEmail(e.target.value)}
                  type="email"
                  label={translations.CreateUserEmail}
                  fullWidth
                  name="user-email"
                  autoComplete="new-email"
                />
                <MDInput
                  onChange={(e) => SetPassword(e.target.value)}
                  type="password"
                  label={translations.CreateUserpassword}
                  fullWidth
                  name="user-password"
                  autoComplete="new-password"
                />
                <MDInput
                  onChange={(e) => SetConfirmPassword(e.target.value)}
                  type="password"
                  label={translations.CreateUserConfirmPassword}
                  fullWidth
                  name="user-confirm-password"
                  autoComplete="new-password"
                />
              </div>

              {/* Name - Mandatory */}
              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  autoComplete="new"
                  label={translations.CreateUserName}
                  fullWidth
                  InputLabelProps={{ style: { fontSize: "1.07rem" } }}
                  inputProps={{ style: { fontSize: "1.07rem" } }}
                />
              </div>

              {/* Phone Number - Mandatory */}
              <div
                className="col-md-4 mt-3"
                style={{ position: "relative", zIndex: "15" }}
              >
                <MDBox position="relative">
                  <PhoneInput
                    country="eg"
                    value={Number}
                    onChange={(value) => SetNumber(value)}
                    enableSearch={true}
                    autoComplete="new"
                    inputStyle={{
                      width: "100%",
                      height: "45px",
                      fontSize: "1.07rem",
                      border: "1px solid #d2d6da",
                      borderRadius: "8px",
                      paddingLeft: "48px",
                      paddingRight: "12px",
                      backgroundColor: "transparent",
                      fontFamily: "inherit",
                    }}
                    buttonStyle={{
                      border: "1px solid #d2d6da",
                      borderRight: "none",
                      borderRadius: "8px 0 0 8px",
                      backgroundColor: "transparent",
                    }}
                    containerStyle={{
                      width: "100%",
                      position: "relative",
                      zIndex: 15,
                    }}
                  />
                </MDBox>
              </div>

              {/* --- Nationality Group Field - ADDED HERE --- */}
              <div
                className="col-md-4 mt-3"
                style={{
                  position: "relative",
                  zIndex: "14",
                  fontSize: "1.27rem",
                }}
              >
                <Select
                  placeholder="Nationality Group (Required)"
                  value={NationalityGroup}
                  onChange={(option) => setNationalityGroup(option)}
                  options={NationalityGroupOptions}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      height: "45px",
                      borderRadius: "8px",
                      borderColor: "#d2d6da",
                      fontSize: "1.07rem",
                      textAlign:
                        translations.setlang === "ar" ? "right" : "left",
                      direction: translations.setlang === "ar" ? "rtl" : "ltr",
                    }),
                    placeholder: (base) => ({
                      ...base,
                      fontSize: "1.07rem",
                    }),
                  }}
                />
              </div>

              {/* Address */}
              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => SetAddress(e.target.value)}
                  type="text"
                  autoComplete="new"
                  label={`${translations.CreateUserAddress} (optional)`}
                  fullWidth
                  InputLabelProps={{ style: { fontSize: "1.07rem" } }}
                  inputProps={{ style: { fontSize: "1.07rem" } }}
                />
              </div>

              {/* Birth Date */}
              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setBirthdayDate(e.target.value)}
                  type="date"
                  label={`${translations.CreateUserBirthday} (optional)`}
                  fullWidth
                  autoComplete="off"
                  InputLabelProps={{
                    shrink: true,
                    style: { fontSize: "1.07rem" },
                  }}
                  inputProps={{ style: { fontSize: "1.07rem" } }}
                />
              </div>

              {/* Gender */}
              <div
                className="col-md-4 mt-3"
                style={{
                  position: "relative",
                  zIndex: "12",
                  fontSize: "1.27rem",
                }}
              >
                <Select
                  placeholder={`${translations.CreateUserGender} (optional)`}
                  onChange={(e) => SetGender(e.value)}
                  options={GenderOptions}
                  styles={{
                    control: (base) => ({
                      ...base,
                      direction: translations.setlang === "ar" ? "rtl" : "ltr",
                    }),
                  }}
                />
              </div>

              {/* National/Passport ID */}
              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setNationalPassportId(e.target.value)}
                  type="text"
                  label={`${translations.CreateUserNationalID} (optional)`}
                  fullWidth
                  InputLabelProps={{ style: { fontSize: "1.07rem" } }}
                  inputProps={{ style: { fontSize: "1.07rem" } }}
                />
              </div>

              {/* Nationality Selector */}
              <div
                className="col-md-4 mt-3"
                style={{
                  position: "relative",
                  zIndex: "10",
                  fontSize: "1.27rem",
                }}
              >
                <CountrySelector
                  label={`${translations.CreateUserNationality} (optional)`}
                  SetNationality={SetNationality}
                />
              </div>

              {/* Relative Number */}
              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setRelativeNumber(e.target.value)}
                  type="text"
                  label={`${translations.CreateUserRelativeNumber} (optional)`}
                  fullWidth
                  InputLabelProps={{ style: { fontSize: "1.07rem" } }}
                  inputProps={{ style: { fontSize: "1.07rem" } }}
                />
              </div>

              {/* Referral */}
              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setReferral(e.target.value)}
                  type="text"
                  label={`Referral (optional)`}
                  autoComplete="off"
                  fullWidth
                  InputLabelProps={{ style: { fontSize: "1.07rem" } }}
                  inputProps={{ style: { fontSize: "1.07rem" } }}
                />
              </div>

              {/* Medications */}
              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setMedications(e.target.value)}
                  type="text"
                  label={`${translations.CreateUserDoyouhaveMedicationsconstantly} (optional)`}
                  fullWidth
                  InputLabelProps={{ style: { fontSize: "1.07rem" } }}
                  inputProps={{ style: { fontSize: "1.07rem" } }}
                />
              </div>

              {/* Sensitivity */}
              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setSensitivity(e.target.value)}
                  type="text"
                  label={`${translations.CreateUserDoyouhaveSensitivitytoanything} (optional)`}
                  fullWidth
                  InputLabelProps={{ style: { fontSize: "1.07rem" } }}
                  inputProps={{ style: { fontSize: "1.07rem" } }}
                />
              </div>

              {/* Chronic Diseases */}
              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setChronicDiseases(e.target.value)}
                  type="text"
                  label={`${translations.CreateUserDoyouhaveChronicDiseases} (optional)`}
                  fullWidth
                  InputLabelProps={{ style: { fontSize: "1.07rem" } }}
                  inputProps={{ style: { fontSize: "1.07rem" } }}
                />
              </div>

              {/* Error Message */}
              <div className="col-md-4 mt-3">
                <MDBox mt={4} mb={1}>
                  <MDTypography
                    variant="overline"
                    color="error"
                    style={{ fontSize: "1.07rem" }}
                  >
                    {ErrorText}
                  </MDTypography>
                </MDBox>
              </div>
            </div>
          </MDBox>
        </MDBox>
      </Card>
    </DashboardLayout>
  );
};

export default CreateClient;
